import React from 'react';
import RichTextEditor from '../../../../../product/components/common/RichTextEditor';

const RichText = (props) => {
    const { field } = props;
    const value = props.fieldValues[field.key] || field.value || '';

    return (
        <div className="mb-3">
            {field.label && (
                <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.6)', marginBottom: 4 }}>
                    {field.label}{field.required ? ' *' : ''}
                </div>
            )}
            <RichTextEditor description={value} setDescription={(html) => props.onChange(field, html)} />
        </div>
    );
};

export default RichText;
